import React from 'react';
import { marked } from 'marked';
import { renderToString } from 'react-dom/server';
import { Table, TableHeaderCell, TableRow, TableCell, Text, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
const StyledTableCell = styled(TableCell) `
  text-align: start;
`;
const StyledTableHeaderCell = styled(TableHeaderCell) `
  text-align: start;
`;
export const adjustVariant = (variant) => {
    switch (variant) {
        case 'heading1':
            return { variant: 'titleLarge', paddingBottom: '0.67em' };
        case 'heading2':
            return { variant: 'titleMedium', paddingBottom: '0.75em' };
        case 'heading3':
            return { variant: 'titleSmall' };
        case 'heading4':
            return { variant: 'titleSmall', fontSize: '18px' };
        default:
            return { variant };
    }
};
export const renderLink = (href, title, text) => {
    const target = title !== 'internal' ? '_blank' : '_self';
    return `<a href="${href}" target="${target}" rel="noopener noreferrer">${text || title}</a>`;
};
export const spotifyWidgetParagraph = (text) => {
    if (text.indexOf('[play-button') === 0) {
        const [, uri, compact] = /\[play-button\s+(spotify:[\w:]+)(?:\s+(compact))?\]/g.exec(text);
        const height = compact === 'compact' ? 80 : 380;
        return `<iframe
      src="https://open.spotify.com/embed?uri=${uri}"
      width="300"
      height="${height}"
      frameborder="0"
      allowtransparency="true"
      allow="encrypted-media">
    </iframe>`;
    }
    return text;
};
export class DefaultRenderer extends marked.Renderer {
    link(...args) {
        return renderLink.apply(this, args);
    }
    paragraph(text) {
        const str = spotifyWidgetParagraph(text);
        return super.paragraph(str);
    }
    heading(text, level) {
        const variant = `heading${level}`;
        const { variant: variantAdjusted, ...styles } = adjustVariant(variant);
        const variantProp = { ['variant']: variantAdjusted };
        const typeAs = `h${level}`;
        return renderToString(React.createElement(Text, { as: typeAs, ...variantProp, style: styles, dangerouslySetInnerHTML: { __html: text } }));
    }
    hr() {
        return '';
    }
    table(header, body) {
        return renderTable(header, body);
    }
}
function renderTable(header, body) {
    const headerCells = header
        .split(/<th>(.*)<\/th>/)
        .map(val => val === null || val === void 0 ? void 0 : val.replace(/<[/]?t[rh]{1}>/, '').trim())
        .filter(Boolean)
        .map((val, i) => (React.createElement(StyledTableHeaderCell, { key: `th-${i}`, dangerouslySetInnerHTML: { __html: val } })));
    const bodyRows = body
        .split(/<tr>/)
        .map(val => val === null || val === void 0 ? void 0 : val.replace('</tr>', '').trim())
        .filter(Boolean)
        .map((val, i) => {
        const cells = val
            .split(/<td>(.*)<\/td>/)
            .map(cellVal => cellVal === null || cellVal === void 0 ? void 0 : cellVal.trim())
            .filter(Boolean)
            .map((cellVal, j) => (React.createElement(StyledTableCell, { key: `td-${i}-${j}`, dangerouslySetInnerHTML: { __html: cellVal } })));
        return React.createElement(TableRow, { key: `tr-${i}` }, cells);
    });
    const output = (React.createElement(Table, null,
        React.createElement("thead", null,
            React.createElement(TableRow, null, headerCells)),
        React.createElement("tbody", null, bodyRows)));
    return renderToString(output);
}
